import React, { useContext } from "react";
import './cursor.styles.scss'
import useMousePosition from "../../hooks/useMousePosition";
import { MouseContext } from "../../context/mouse-context";

import { BsArrowRight } from 'react-icons/bs';
import { BsArrowLeft } from 'react-icons/bs';

const Cursor = ({isDesktop, canAccess}) => {
  const { cursorType, cursorChangeHandler } = useContext(MouseContext);
  const { x, y } = useMousePosition();
  // console.log(cursorType)
  if (!isDesktop) return <></>
  return (
    <div
      className={`cursor-wrapper`}
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      <div className={`cursor ${!canAccess ? 'cursor-white' : ''} ${cursorType == 'active' ? 'cursor-active' : 'cursor-passive'}`}>
        
      </div>
    </div>
  );
};

export default Cursor;
